module.exports = __webpack_public_path__ + "static/media/background-2-1920w.cc70ac68.jpg";